module.exports = __webpack_public_path__ + "assets/img/dt_server.f5bfdcd2.png";